/**
 * Export roles.
 */
export const AUTH_ROLES = {
  PARTNERSHIP_ADMIN: 'PSHIP_ADMIN',
  PARTNERSHIP_BROWSER_ACCESS: 'PSHIP_BROWSER_ACCESS',
  PARTNERSHIP_CAMPAIGN_OND: 'PSHIP_CAMPAIGN_OND',
  PARTNERSHIP_MEMBER: 'PSHIP_MEMBER',
  PARTNERSHIP_OWNER: 'PSHIP_OWNER',
  PARTNERSHIP_PROZIS_CLUB: 'PSHIP_PROZIS_CLUB',
  PARTNERSHIP_SIMPLE_USER: 'PSHIP_SIMPLE_USER',
  PARTNERSHIP_SIS: 'PSHIP_SIS',
  PARTNERSHIP_SN_LIVE_DIRECT_PROZIS_USER: 'PSHIP_SN_LIVE_DIRECT_PROZIS_USER',
  PARTNERSHIP_SN_LIVE_SCHEDULE_PROZIS_USER:
    'PSHIP_SN_LIVE_SCHEDULE_PROZIS_USER',
  PARTNERSHIP_SN_LIVE_USER: 'PSHIP_SN_LIVE_PROZIS_USER',
  PARTNERSHIP_SOCIAL_NETWORK_USER: 'PSHIP_SN_PROZIS_USER',
  PARTNERSHIP_SUPERVISOR: 'PSHIP_SUPERVISOR',
  PARTNERSHIP_SUPPORT: 'PSHIP_SUPPORT',
  PARTNERSHIP_USER: 'PSHIP_USER'
};
